import React from "react";
import "../../../../css/Marketing/FinancialPromotions/Buttons/PassFailStatusOption.css";

const normalizeTone = (tone) => {
  const normalized = String(tone || "")
    .trim()
    .toLowerCase();
  return normalized === "failed" ? "failed" : "passed";
};

const toLabel = (tone, label) => {
  if (label) return label;
  return tone === "failed" ? "Reject" : "Accept";
};

export const PassFailStatusOption = ({
  tone = "passed",
  selected = false,
  label,
  className = "",
  onClick,
  type = "button",
  disabled = false,
}) => {
  const normalizedTone = normalizeTone(tone);
  const text = toLabel(normalizedTone, label);

  return (
    <button
      type={type}
      className={`fp-passfail-option fp-passfail-option--${normalizedTone} ${selected ? "is-selected" : ""} FP_Content_Semibold ${className}`.trim()}
      aria-pressed={selected}
      onClick={onClick}
      disabled={disabled}
    >
      <span className="fp-passfail-option__icon" aria-hidden="true" />
      <span className="FP_Content">{text}</span>
    </button>
  );
};

export const PassedStatusOption = (props) => (
  <PassFailStatusOption {...props} tone="passed" />
);

export const FailedStatusOption = (props) => (
  <PassFailStatusOption {...props} tone="failed" />
);

export default PassFailStatusOption;
